import { memo } from 'react';
import LoadingText from './LoadingText';

const SPINNER = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    className="status-message__spinner"
  >
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);

/**
 * StatusMessage - Standardized status/loading/error message box
 *
 * @param {'loading'|'success'|'error'|'info'} [type='info'] - Message type
 * @param {string} message - The message to display
 * @param {boolean} [showSpinner] - Show spinner (defaults true for loading)
 */
const StatusMessage = ({ type = 'info', message, showSpinner }) => {
  if (!message) return null;

  const shouldSpin = showSpinner ?? type === 'loading';
  const content = type === 'loading' ? <LoadingText>{message}</LoadingText> : message;

  return (
    <div
      className={`status-message status-message--${type}`}
    >
      {shouldSpin && SPINNER}
      {content}
    </div>
  );
};

export default memo(StatusMessage);
